import http from './http'
const base = '/Telas/AutomacaoBancaria'
export default {
  async get () { return (await http.get(`${base}/Get`)).data },
  async getOptions () { return (await http.get(`${base}/GetOptions`)).data },
  async enqueue (input) { return (await http.post(`${base}/Enqueue`, input)).data },
  async process (id) { await http.post(`${base}/Process/${id}`) },
  async retry (id) { await http.post(`${base}/Retry/${id}`) }
}
